import { Router, ActivatedRoute } from '@angular/router';
import { appConfig } from 'src/app/_core/config/app-config.const';
import { Location } from '@angular/common';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NgNavigatorShareService } from 'ng-navigator-share';
import { ToastrService } from 'ngx-toastr';
import { TinyUrlService } from '../../services/tinyurl.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'share-tangram',
  templateUrl: './share-tangram.component.html',
  styleUrls: ['./share-tangram.component.scss']
})
export class ShareTangramComponent implements OnInit {
  imgPath = appConfig.imagePath;
  iconPath = appConfig.iconPath;
  pathwayId: string = "";
  whatsAppShareUrl: string = '';
  fbShareUrl: string = '';
  inAppShareUrl: string = ''; // Add missing inAppShareUrl property
  shareUrl: any = '';
  
  // Base URL for embedded modal popup
  baseUrl: string = '';
  
  publicUrl: string = '';
  isIOs: boolean = false;
  private ngNavigatorShareService: NgNavigatorShareService;

  // Embed modal properties
  @ViewChild('EmbedModalPopupContent', { static: true }) embedModalPopupContent!: TemplateRef<any>;
  window = window; // Make window accessible in template

  constructor(
    private modalService: NgbModal,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    ngNavigatorShareService: NgNavigatorShareService,
    private toasterService: ToastrService,
    private tinyUrlService: TinyUrlService,

  ) {
    this.ngNavigatorShareService = ngNavigatorShareService;
  }


  async ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        this.pathwayId = params.pathwayId;
        this.publicUrl = environment.appRedirectUrl + '/#/dashboard/' + this.pathwayId
      }
      );
    this.fbShareUrl = environment.fbShareUrl;
    this.shareUrl = await this.shortenUrlFunc(this.publicUrl)    
    // this.shareUrl = this.publicUrl;
    this.isIOs = /iphone|ipad/i.test(navigator.userAgent);

    const details = navigator.userAgent;

    const regexp = /android|iphone|kindle|ipad/i;
    const isMobileDevice = regexp.test(details);

    if (isMobileDevice) {
      this.whatsAppShareUrl = environment.whatsAppShareUrlMobile;
    } else {
      this.whatsAppShareUrl = environment.whatsAppShareUrl;
    }
  }

  copyToClipboard(event) {
    const element: any = document.getElementById("share-tangram-url");
    // let elementText = element.getAttribute('value');
    // this.copyText(this.publicUrl);
    this.copyText(element.value);
    this.toasterService.success('Link copied to clipboard');
  }

  copyText(text) {
    navigator.clipboard.writeText(text);
  }

  backButton() {
    // this.location.back();
    this.router.navigate(['/dashboard', this.pathwayId]);
  }

  /**
 * redirects user to share popup
 * @param link to be shared
 */
  shareRedirect(appUrl, link) {
    const shareURL = appUrl ? appUrl + encodeURIComponent(link) : link;
    window.open(shareURL, 'popup', 'width=600,height=600');
    return false;
  }

  shareRedirectWithIOs(shareUrl) {
    this.ngNavigatorShareService.share({
      title: '',
      // text: 'Sharing My tangram',
      url: shareUrl
    }).then((response) => {
      console.log(response);
    })
      .catch((error) => {
        console.log(error);
      })
  }

  async shortenUrlFunc(longUrl) {
    try {
      const response: any = await this.tinyUrlService.shortenUrl(longUrl).toPromise();
      return response.data.tiny_url; // Return the shortened URL
    } catch (error) {
      console.error('Error occurred while shortening URL:', error);
      this.toasterService.error(error)
      return this.publicUrl
    }
  }

  /**
 * Capitalize first letter of a string
 * @param str string to capitalize
 * @returns capitalized string
 */
  private capitalizeFirstLetter(str: string): string {
    // This method is no longer needed
    return '';
  }

  /**
   * Open embed modal
   */
  openEmbedModal() {
    this.modalService.open(this.embedModalPopupContent, {
      centered: true,
      windowClass: 'embed-modal-popup',
      size: 'lg'
    });
  }
}
